import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
require("highcharts/modules/accessibility")(Highcharts);

export default function GizmozGraph({ id, simObj, setSimObj,getUserData }) {
    const [gizmosObj, setGizmosObj] = useState({
        'noofgizmos': null,
        'quarterlygizmos': null,
        'totalcmp1': null,
        'totalcmp1order': null,
        'totalcmp2': null,
        'totalcmp2order': null
    });
    const [isUserDataUpdated,setIsDataUpdated] = useState(false);
    const noOfGizmosCompleted = parseInt(simObj?.laststate?.noOfGizmosCompleted);
    const quarterlyGizmosTarget = parseInt(simObj?.laststate?.quarterlyGizmosTarget);
    const totalComponent1Completed = parseInt(simObj?.laststate?.totalComponent1Completed);
    const totalComponent1Ordered = parseInt(simObj?.laststate?.totalComponent1Ordered);
    const totalComponent2Completed = parseInt(simObj?.laststate?.totalComponent2Completed);
    const totalComponent2Ordered = parseInt(simObj?.laststate?.totalComponent2Ordered);
    const quarter = simObj?.laststate?.quarter;
    const percentage = (noOfGizmosCompleted / quarterlyGizmosTarget) * 100;
    function formatNumberWithCommas(number) {
        //Added for tooltip formatter to 1,334
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    function applyAccessibility(chart) {
        if (chart && chart.renderTo) {
            const svg = chart.renderTo.querySelector("svg.highcharts-root");
            if (svg) {
            // Force override *after* Highcharts touches it
            setTimeout(() => {
                svg.setAttribute("role", "img");
                svg.setAttribute(
                "aria-label",
                `Gizmos Quarterly Goal Q${quarter} Manufactured out of target graph.`
                );

                const oldDesc = svg.querySelector("desc");
                if (oldDesc) oldDesc.remove();

                const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
                desc.textContent =
                `Pie chart showing progress towards the gizmos manufacturing goal for Quarter ${quarter}. ` +
                `The target is ${quarterlyGizmosTarget} gizmos. Completed: ${noOfGizmosCompleted}.`;
                svg.insertBefore(desc, svg.firstChild);
            }, 0);
            }
        }
    }
    var chart = {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        marginTop: 50,
        events: {
            render: function () {
                applyAccessibility(this);
            },
            redraw: function () {
                applyAccessibility(this);
            }
        }
    };
    var title = {
        text: `${(simObj?.userData && simObj?.userData!="") ? getUserData(simObj?.userData,2).charAt(0).toUpperCase() + getUserData(simObj?.userData,2).slice(1) : "Gizmos"} Quarterly Goal Q${quarter} Manufactured Out of Target`,
        align: "left",
        style: {
            fontSize: "12px",
        },
    };
    var credits = {
        enabled: false, // Disable the Highcharts bottom link
    };
    var tooltip = {
        formatter: function () {
            //<strong>${this.key} Percentage: ${this.percentage.toFixed(2)}%</strong><br/>
            return `<span>${(simObj?.userData && simObj?.userData!="") ? getUserData(simObj?.userData,2).charAt(0).toUpperCase() + getUserData(simObj?.userData,2).slice(1) : "Gizmos"} Quarterly Goal Q${quarter}: <strong>${formatNumberWithCommas(quarterlyGizmosTarget)}</strong></span><br/>Manufactured Out of Target: <strong>${formatNumberWithCommas(noOfGizmosCompleted)}</strong><br/><hr/><br/>${formatNumberWithCommas(simObj?.compnent1ToBeOrdered)} Of SKU1 Received: <strong>${formatNumberWithCommas(totalComponent1Completed)}</strong><br/>SKU1 Ordered Units: <strong>${formatNumberWithCommas(totalComponent1Ordered)}</strong><br/><hr/><br/>${formatNumberWithCommas(simObj?.compnent2ToBeOrdered)} Of SKU2 Received: <strong>${formatNumberWithCommas(totalComponent2Completed)}</strong><br/>SKU2 Ordered Units: <strong>${formatNumberWithCommas(totalComponent2Ordered)}</strong></span>`;
        },
        borderWidth: 2,
        style: {
            borderColor: function () {
                return this.point.color; // Set the tooltip box border color to match the point color
            },
            opacity: 0.9,
            fontSize: '11px',
        }
    };
    var legend = {
        enabled: false,
        align: "left",
        itemStyle: {
            fontWeight: "bold",
            fontSize: "11px",
        },
    };

    var plotOptions = {
        pie: {
            center: [null, 80],
            dataLabels: {
                enabled: false,
            },

            showInLegend: false,
            point: {
                events: {
                    legendItemClick: function (e) {
                        return false;
                    }
                }
            }
        },
    };
    var series = [
        {
            type: "pie",
            // innerSize: "30%",
            borderRadius: 0,
            data: [{
                name: `${(simObj?.userData && simObj?.userData!="") ? getUserData(simObj?.userData,2).charAt(0).toUpperCase() + getUserData(simObj?.userData,2).slice(1) : "Gizmos"} Completed`,
                y: percentage, //
                //color: "#3E8725", // Set the background color for 'Ordering Cost'
                color: {
                    pattern: {
                      path: 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11',
                      width: 10,
                      height: 10,
                      color: '#FFFFFF',
                      backgroundColor: '#3E8725'
                    },
                  }
            },
            {
                name: `${(simObj?.userData && simObj?.userData!="") ? getUserData(simObj?.userData,2).charAt(0).toUpperCase() + getUserData(simObj?.userData,2).slice(1) : "Gizmos"} Remaining`,
                y: 100 - percentage,
                //color: "#c6c9c5", // Set the background color for 'Ordering Cost'
                color: {
                    pattern: {
                        path: 'M 0 5 L 10 5', // Horizontal line
                        width: 10,
                        height: 10,
                        color: '#FFFFFF', // Line color (white)
                        backgroundColor: 'rgb(80, 87, 89)' // Background color (red)
                    }
                },
            }],
            states: {
                inactive: {
                    enabled: false,
                },
            },
        },
    ];
    var accessibility = {
        enabled: true,
        description: null,
        pointDescriptionFormatter: function (point) {
            return `${(quarterlyGizmosTarget != undefined) ? `${(simObj?.userData && simObj?.userData!="") ? simObj.userData.charAt(0).toUpperCase() + simObj.userData.slice(1) : "Gizmos"} Quarterly Goal Q${quarter}: ${formatNumberWithCommas(quarterlyGizmosTarget)}` : ``}; ${(noOfGizmosCompleted != undefined) ? `Manufactured Out of Target: ${formatNumberWithCommas(noOfGizmosCompleted)}` : ``}; ${(totalComponent1Completed != undefined) ? `25,000 Of SKU1 Received: ${formatNumberWithCommas(totalComponent1Completed)}` : ``}; ${(totalComponent1Ordered != undefined) ? `SKU1 Ordered Units: ${formatNumberWithCommas(totalComponent1Ordered)}` : ``}; ${(totalComponent2Completed != undefined) ? `100,000 Of SKU2 Received: ${formatNumberWithCommas(totalComponent2Completed)}` : ``}; ${(totalComponent2Ordered != undefined) ? `SKU2 Ordered Units: ${formatNumberWithCommas(totalComponent2Ordered)}` : ``};`;
        },
        screenReaderSection: {
            beforeChartFormat: '' // disables their auto "Interactive chart" label
        }
    };
    var json = {};
    json.chart = chart;
    json.credits = credits;
    json.title = title;
    json.tooltip = tooltip;
    json.legend = legend;
    json.series = series;
    json.plotOptions = plotOptions;
    json.accessibility = accessibility;
    const initGraph = () => {
        Highcharts?.chart(`${id}`, json);
    };
    useEffect(() => {
        if (gizmosObj?.noofgizmos != noOfGizmosCompleted || gizmosObj?.quarterlygizmos != quarterlyGizmosTarget || gizmosObj?.totalcmp1 != totalComponent1Completed || gizmosObj?.totalcmp1order != totalComponent1Ordered || gizmosObj?.totalcmp2 != totalComponent2Completed || gizmosObj?.totalcmp2order != totalComponent2Ordered || (simObj?.userData && simObj?.userData != "" && !isUserDataUpdated)) {
            // debugger
            setGizmosObj({
                'noofgizmos': noOfGizmosCompleted,
                'quarterlygizmos': quarterlyGizmosTarget,
                'totalcmp1': totalComponent1Completed,
                'totalcmp1order': totalComponent1Ordered,
                'totalcmp2': totalComponent2Completed,
                'totalcmp2order': totalComponent2Ordered
            })
            if(simObj?.userData && simObj?.userData != "" && !isUserDataUpdated){
                setIsDataUpdated(true)
            }
            initGraph();
        }
    }, [id, simObj?.laststate,simObj?.userData]);
    return (
        <div
            id={id}
            style={{ height: "240px" }}
            aria-label="Gizmoz Graph"
            className="GizmozGraph"
        ></div>
    );
}
